import { ModalDismiss } from '@apps-common/config/modal'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { useIonModal } from '@ionic/react'
import { invalidateTriggerQueries } from '../../../../../../../../../lib/invalidateTriggerQueries'
import { ITriggerModifyModalProps, TriggerModifyModal } from '../modals/trigger-modify-modal/TriggerModifyModal'

export const useTriggerModifyModal = ({ status, unitId, productId, triggerId }: ITriggerModifyModalProps) => {
  const [present, dismiss] = useIonModal(TriggerModifyModal, {
    componentProps: {
      status,
      unitId,
      productId,
      triggerId
    },
    onDismiss: (data: string, role: string) => {
      if (role === ModalDismiss.Confirm) {
        invalidateTriggerQueries(triggerId, unitId)
      }
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return {
    present: () => {
      present({
        enterAnimation: modalSlideUpEnterAnimation,
        leaveAnimation: modalSlideUpLeaveAnimation,
        backdropDismiss: true
      })
    },
    dismiss
  }
}
